import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { ArrowLeftOnRectangleIcon } from '@heroicons/react/24/outline';

const SuperAdminHeader = () => {
    const { user, logout } = useContext(AuthContext);

    return (
        <header className="bg-white shadow-sm !z-[200]">
            <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* This can be a placeholder or a welcome message */}
                    <div>
                        <h1 className="text-xl font-semibold text-gray-700">ERP Management Panel</h1>
                    </div>
                    
                    {/* User info and Logout button */}
                    <div className="flex items-center gap-4">
                        <span className="text-sm text-gray-600">
                            Welcome, <span className="font-medium text-gray-800">{user?.name || 'Admin'}</span>
                        </span>
                        
                        <button
                            onClick={logout}
                            className="flex items-center gap-2 text-sm font-semibold text-red-600 hover:text-red-800"
                            title="Logout"
                        >
                            <ArrowLeftOnRectangleIcon className="h-5 w-5" />
                            <span>Logout</span>
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default SuperAdminHeader;